// NaverMap.tsx
import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { AddressItem } from './NaverMapWrapper';

interface NaverMapProps {
  addresses?: AddressItem[];
  // managerAddresses: AddressItem[];
}

const NaverMap: React.FC<NaverMapProps> = ({ addresses = [] }) => {
  const mapElement = useRef<HTMLDivElement | null>(null);
  const mapRef = useRef<naver.maps.Map | null>(null);
  const markersRef = useRef<naver.maps.Marker[]>([]);

  const minZoomLevel = 14;

  //치영 추가250206 (엠마우스 고정좌표)
  const fixedLocations: AddressItem[] = [
    {
      address: '광주 광산구 용아로 808',
      clientName: '엠마우스산업',
      latitude: 35.2152713632093,
      longitude: 126.804933530437,
    },
  ];

  useEffect(() => {
    const { naver } = window as any;

    if (!mapElement.current || !naver) return;

    if (!mapRef.current) {
      mapRef.current = new naver.maps.Map(mapElement.current, {
        center: new naver.maps.LatLng(37.5665, 126.978),
        zoom: 0,
      });
    }
    const map = mapRef.current!; // map이 null이 아님을 명시

    // 기존 마커 제거
    markersRef.current.forEach((marker) => marker.setMap(null));
    markersRef.current = [];

    const validCoords: naver.maps.LatLng[] = [];

    const addMarkers = (items: AddressItem[], color: string) => {
      return items.map((item: AddressItem) => {
        if (item.latitude == null || item.longitude == null) {
          console.error(`주소를 찾을 수 없습니다: ${item.address}`);
          return;
        }

        const coords = new naver.maps.LatLng(item.latitude, item.longitude);

        // 기본 마커 모양과 유사한 커스텀 SVG 아이콘 정의
        // const markerIcon = {
        //   content: `
        //     <svg width="24" height="37" viewBox="0 0 24 37" xmlns="http://www.w3.org/2000/svg">
        //       <path d="M12 0C5.37258 0 0 5.37258 0 12C0 21 12 37 12 37C12 37 24 21 24 12C24 5.37258 18.6274 0 12 0Z" fill="${color}" stroke="#000" stroke-width="1"/>
        //       <circle cx="12" cy="12" r="5" fill="#fff"/>
        //     </svg>
        //   `,
        //   size: new naver.maps.Size(20, 33),
        //   anchor: new naver.maps.Point(12, 33),
        // };
        const markerIcon = {
          content: `
                    <div style="position: relative; width: 24px; height: 37px;">
                      <!-- 클라이언트 이름 표시 -->
                      <div style="
                        position: absolute;
                        top: -15px;
                        left: 25px;
                        background-color: rgba(255, 255, 255, 0.9);
                        padding: 3px 6px;
                        border-radius: 4px;
                        font-size: 12px;
                        white-space: nowrap;
                        overflow:hidden;
                        text-overflow: ellipsis;
                        max-width: 135px;
                        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
                      ">
                        ${item.clientName}
                      </div>
                
                      <!-- 마커 아이콘 -->
                      <svg width="24" height="37" viewBox="0 0 24 37" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 0C5.37258 0 0 5.37258 0 12C0 21 12 37 12 37C12 37 24 21 24 12C24 5.37258 18.6274 0 12 0Z" 
                          fill="${color}" stroke="#000" stroke-width="1"/>
                        <circle cx="12" cy="12" r="5" fill="#fff"/>
                      </svg>
                    </div>
                  `,
          size: new naver.maps.Size(20, 33),
          anchor: new naver.maps.Point(12, 33),
        };

        const marker = new naver.maps.Marker({
          position: coords,
          map: map,
          icon: markerIcon,
          title: item.clientName,
        });

        const infoWindow = new naver.maps.InfoWindow({
          content: `<div style="padding:5px; font-size:12px;">${item.clientName}</div>`,
          disableAnchor: false,
          backgroundColor: 'white',
          borderColor: 'gray',
          borderWidth: 1,
          anchorSize: new naver.maps.Size(10, 10),
          anchorSkew: true,
          pixelOffset: new naver.maps.Point(0, 0),
        });

        // // 기본적으로 InfoWindow 열기
        // infoWindow.open(map, marker);

        // naver.maps.Event.addListener(marker, 'click', () => {
        //   if (infoWindow.getMap()) {
        //     infoWindow.close();
        //   } else {
        //     infoWindow.open(map, marker);
        //   }
        // });

        markersRef.current.push(marker);
        validCoords.push(coords);
      });
    };

    const fixedMarkerPromises = addMarkers(fixedLocations, '#000000'); // 엠마우스 고정 좌표 검정색 - 치영추가250206
    const normalMarkerPromises = addMarkers(addresses, '#ff0000'); // 빨간색
    // const managerMarkerPromises = addMarkers(managerAddresses, '#0000ff'); // 파란색

    //치영추가250206 fixedMarkerPromises
    //두 개의 마커 생성 비동기 작업을 하나의 배열에 합쳐서 Promise.all()이 동시에 실행
    Promise.all([...fixedMarkerPromises, ...normalMarkerPromises]).then(() => {
      if (validCoords.length > 0) {
        const bounds = new naver.maps.LatLngBounds();
        validCoords.forEach((coord) => bounds.extend(coord));
        map.fitBounds(bounds);
        if (
          mapRef.current?.getZoom() &&
          mapRef.current.getZoom() > minZoomLevel
        ) {
          mapRef.current?.setZoom(minZoomLevel);
        }
      } else {
        console.warn('유효한 주소가 없어 지도의 범위를 설정하지 않습니다.');
      }
    });
  }, [addresses]);

  return <Container ref={mapElement} />;
};

export default NaverMap;

const Container = styled.div`
  flex: 1;
  width: 100%;
  height: 100%;
`;
